import React, { useState } from "react";
import { f7 } from "framework7-react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import axios from "axios";
import { API_BASE_URL, API_AUTH } from "./../globals";
import CustomPopup from "./CustomPopup"; // Import the CustomPopup component

const CheckoutForm = ({ amountToPay, paymentData }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [paymentStatus, setPaymentStatus] = useState("");
  const [issubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    // Check if Stripe and Elements are ready
    if (!stripe || !elements) {
      setPaymentStatus("Payment processing is not available at the moment.");
      setIsSubmitting(false); // Reset issubmitting to false
      return;
    }

    // Create a PaymentMethod
    // const { paymentMethod, error } = await stripe.createPaymentMethod({
    //   type: 'card',
    //   card: elements.getElement(CardElement),
    // });

    const { token, error } = await stripe.createToken(
      elements.getElement(CardElement)
    );

    console.log("token", token.id);

    if (!error) {
      try {
        const customHeaders = {
          Authorization: "Basic " + API_AUTH, // Replace with your authorization token if needed
        };

        // Send the paymentMethod to your server
        const response = await axios.post(
          API_BASE_URL + "stripe/charge",
          {
            token: token.id, // Send the paymentMethod ID, not the entire object
            amount: amountToPay,
            paymentdata: paymentData,
          },
          {
            headers: customHeaders,
          }
        );
        // console.log(response.data.status)
        if (response.data.status === "succeeded") {
          // Set a success message in the component state
          setPaymentStatus("Payment successful!");
          f7.views.main.router.navigate("/payment-success/");
        } else {
          // Handle server response indicating payment failure
          setPaymentStatus(`Payment failed: ${response.data.error}`);
        }

        // // Retrieve the clientSecret from the server response
        // const clientSecret = response.data.clientSecret;

        // console.log(clientSecret);
        // // Confirm the payment with Stripe
        // const result = await stripe.confirmCardPayment(clientSecret, {
        //   payment_method: {
        //     card: elements.getElement(CardElement),
        //   },
        // });

        // console.log(result)

        // if (result.error) {
        //   setPaymentStatus(`Payment failed: ${result.error.message}`);
        // } else if (result.status === 'succeeded') {
        //   setPaymentStatus('Payment successful!');
        // } else {
        //   setPaymentStatus('Payment processing...'); // Handle the pending state
        // }
      } catch (serverError) {
        // Handle server-side errors, e.g., 500 Internal Server Error
        console.error("Server Error:", serverError.message);
        setPaymentStatus("Payment processing encountered an issue.");
      }
    } else {
      setPaymentStatus(`Payment failed: ${error.message}`);
    }
    setIsSubmitting(false);
  };

  return (
    <form onSubmit={handleSubmit}>
      <CardElement className="mt-3 mb-3 text-dark" />
      {/* <button className="btn theme-btn w-100 mt-0" type="submit" disabled={!stripe}> Pay </button> */}
      <button
        className="btn theme-btn w-100 mt-0"
        type="submit"
        disabled={!stripe || issubmitting}
      >
        {issubmitting ? "Submitting..." : "Pay"}
      </button>
      {paymentStatus && <p className="text-danger">{paymentStatus}</p>}
    </form>
  );
};

export default CheckoutForm;
